// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__KPQ5V","modalFooterButton":"ModalNotes_modalFooterButton__3-Y59"};